import { render } from "./PhIcons.vue?vue&type=template&id=62c51c80"
import script from "./PhIcons.vue?vue&type=script&lang=js"
export * from "./PhIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__